@if (groups && groups.length) {
  <div class="flex flex-column gap-0" [class]="styleClass">
    @if (label) {
      <app-header
        icon="fas fa-filter"
        [styleClass]="headerStyleClass"
        [text]="label"></app-header>
    }

    <p-dropdown
      placeholder="Alle Gruppen"
      [showClear]="true"
      [options]="groups"
      [(ngModel)]="selection"
      (onChange)="onSelectionChange($event.value)">
      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div class="flex gap-2 align-items-center">
          <i class="fas fa-circle-nodes text-center"></i>
          <span>{{ selectedOption }}</span>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex gap-2 align-items-center">
          <i class="fas fa-circle-nodes text-center"></i>
          <span>{{ item }}</span>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
}
